@if (isLoading) {
    <div class="fancy-loader"></div>
} @else {
    <risk-linkable
        typename="risks"
        displayValueProp="name"
        [linked]="linked"
        [unlinked]="unlinked"
        [orderByValueProperty]="true"
        [disabled]="disabled"
        (linkedChange)="onLinkedItemsChanged($event)"
        [showAdvancedFilters]="true"
        [activeFilters]="activeFilters"
    >
    </risk-linkable>
    @if (
        controlModel &&
        (controlModel.IsShared ||
            (linkedFromOtherOrganization != null && linkedFromOtherOrganization.any()))
    ) {
        <div>
            <risk-linkable
                typename="risks from other organizations"
                displayValueProp="name"
                [linked]="linkedFromOtherOrganization"
                [unlinked]="[]"
                [orderByValueProperty]="true"
                [disabled]="true"
            >
            </risk-linkable>
        </div>
    }
}
